class Notification {
    constructor(Element) {
        const _this = this;
        if(this.length != null) {
            this.notify = Element;
            // Gets the modals id from the attribute data-id="": must be unique
            this.id = this.notify.dataset.id;
            //  Gets the expire date from the modal data-expires="" attribute
            this.expires = new Date(this.notify.dataset.expires);
            // Gets current date time
            this.today = new Date();
            // Sets the object stored in the local storage.
            this.storageObj = {
                viewed: true,
                expires: this.expires
            }
            // Grab storage based on id
            this.storage = JSON.parse(window.localStorage.getItem(`${this.id}`));
            // Defines the close button
            this.closeBtn = this.notify.querySelector('button');
            // Adds an event listener to the close button
            this.closeBtn.addEventListener('click', function(evt) {
                evt.preventDefault();
                _this.close();
            });

            // Checks if there is a local storage for unique id
            //   if there is see if the notification has expried
            if(this.storage !== null) {
                if(this.today > this.expires) {
                    this.open();
                }
            } else {
                this.open();
            }
        }
    }

    open() {
        // Openx modal by settings it's class to .active
        this.notify.classList.add('active');
        // Removes localstorage item based on unique id.
        window.localStorage.removeItem(`${this.id}`);
    }

    close() {
        let _this = this;
        // Closes modal by removing .active class.
        this.notify.classList.remove('active');
        // Removes the modal buttons event listener. 
        this.closeBtn.removeEventListener('click', function(evt) { evt.preventDefault(); _this.close(); });
        // Sets the local storage with unique id and the storageObj.
        window.localStorage.setItem(`${this.id}`, JSON.stringify(this.storageObj));
    }
}

export { Notification as default };